import { ApiResponse, CancelToken } from "apisauce"
import { Api } from "./api"
import { GetTokenResult } from "./api.types"
import { getGeneralApiProblem } from "./api-problem"
import config from "../../utils/config";
import { Toast } from "native-base"

export interface Credential {
  username: string,
  password: string
}

export class TokenApi {
  private api: Api

  constructor(api: Api) {
    this.api = api
  }

  async requestToken(credential: Credential): Promise<GetTokenResult> {
    try {
      // make the api call
      const { BASE_URL, CLIENT_ID, CLIENT_SECRET } = config()
      let timeoutId = null;
      const response: ApiResponse<any> = await this.api.apisauce.post(
        BASE_URL + '/oauth/token',
        {
          grant_type: 'password',
          client_id: CLIENT_ID,
          client_secret: CLIENT_SECRET,
          scope: '*',
          username: credential.username,
          password: credential.password
        },
        {
          cancelToken: new CancelToken(function executor(cancel) {
            timeoutId = setTimeout(() => cancel('Request Timeout'), 15000)
          })
        }
      ).then((response: ApiResponse<any>) => {
        if (response.problem === "CANCEL_ERROR")
          Toast.show({ id: response.problem, title: 'Request Timeout' })
        return response;
      }).finally(() => {
        clearTimeout(timeoutId);
      })

      // the typical ways to die when calling an api
      if (!response.ok) {
        const problem = getGeneralApiProblem(response)
        if (problem) return problem
      }

      const token = response.data

      return { kind: "ok", token }
    } catch (e) {
      // __DEV__ && console.tron.log(e.message)
      return { kind: "bad-data" }
    }
  }
}
